import { storeToRefs } from 'pinia';
import { computed } from 'vue';

import { useUserStore } from '~/store/user';

/**
 * Where the signed-in user's account sits in the reseller/brand tree (ENG-5850 phase 003).
 *
 * Resolved by identity-svc and carried on `/v1/auth/userinfo`, so this reads the user store rather
 * than fetching. `isParent` is the real per-tenant gate for the reseller-only area — the
 * LaunchDarkly flag beside it is only a global kill-switch, because valet's LD client is anonymous
 * and cannot target a single account.
 *
 * Note this is deliberately *not* `isBrandUser`: that is true for any `account_owner`, including a
 * reseller's, so it is the inverse of the signal needed here.
 */
export const useAccountHierarchy = () => {
  const { user } = storeToRefs(useUserStore());

  const hierarchy = computed(() => user.value?.hierarchy);

  return {
    /** True when this account owns child (brand) accounts — i.e. the user works for a reseller. */
    isParent: computed(() => hierarchy.value?.isParent === true),
    /** Set when this account is itself a brand under a reseller. */
    parentAccountId: computed(() => hierarchy.value?.parentAccountId ?? null),
  };
};
